import { useEffect, useState } from "react";
import { useMaterialUIController } from "context";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import configurations from "config";
import { useTranslation } from "react-i18next";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from "@mui/material/CircularProgress";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import 'assets/css/common.css';
import MDBox from "components/MDBox";
import { handleErrors } from "common";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";

function Logout() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [controller, dispatch] = useMaterialUIController();
  const baseUrl = configurations.baseUrl;
  const azureFunctionVendorFrontendKey = configurations.azureFunctionVendorFrontendKey;
  const bearerToken = `Bearer ${localStorage.getItem('JWTToken')}`;
  const userID = localStorage.getItem('userID');
  const [isLoading, setIsLoading] = useState(false);

  const handleLogout = () => {
    setIsLoading(true);
    axios.post(baseUrl + '/vendor/logout', '', {
      headers: { Authorization: bearerToken, function: azureFunctionVendorFrontendKey }
    }).then((response) => {
      // The login was successful, handle the response accordingly
      if (response.status == 200) {
        setIsLoading(false);
        const status = response.data.status;
        const logoutMessage = response.data.message;
        if (status == 1) {
          localStorage.removeItem('userID');
          localStorage.removeItem('JWTToken');
          localStorage.removeItem('profileCompleteStatus');
          localStorage.removeItem('resetPassword');
          localStorage.removeItem('name');
          toast.success(t(logoutMessage))
          const redirectTimeout = setTimeout(() => {
            clearTimeout(redirectTimeout);
            navigate('/vendor/login');
          }, 2000);
        }
        else {
          if (logoutMessage != '')
            toast.error(t(logoutMessage))

          if (response && response.data && response.data.errors) {
            const errorData = response.data.errors;
          }
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    }).catch(error => {
      setIsLoading(false)
      handleErrors(error, t, navigate);
    });
  };

  useEffect(() => {
    handleLogout();
  }, [])

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}><CircularProgress color="inherit" /></Backdrop>
      <MDBox className="logout">{t("logoutNote")}</MDBox>
    </DashboardLayout>
  );
}

export default Logout;
